import AdsError from './AdsError.js'

export class GetSubscriptionSearchResultsAdsError extends AdsError {}
